<template>
  <aside class="flex-0 flex flex-col w-full h-full overflow-y-auto sidebar">
    <div class="flex-shrink-0">
      <Muscle
        v-if="showMuscleCard"
        class="active-muscle"
      ></Muscle>
      <SportMap
        v-if="hasMapCard"
        v-show="mapCardVisible"
        class="sport-map"
      ></SportMap>
    </div>
    <div class="flex-1 flex flex-col collapse-group min-h-[500px]">
      <!-- 体测信息 -->
      <CollapseItem
        v-if="isTestPace"
        :active="collapseStatus.testPace"
        :class="['tab-item']"
        :title="$t('S5532')"
        @toggle="changeCollapseStatus('testPace')"
      >
        <TestPace></TestPace>
      </CollapseItem>
      <!-- 跑姿测试结果 -->
      <CollapseItem
        v-if="hasPostureTest"
        :active="collapseStatus.postureTest"
        :class="['tab-item']"
        :title="$t('H9048')"
        @toggle="changeCollapseStatus('postureTest')"
      >
        <PostureTest :postureTest="activityDetail.summary.postureTest"></PostureTest>
      </CollapseItem>
      <!-- 概要数据-->
      <CollapseItem
        ref="indicatorCollapse"
        :active="collapseStatus.indicators"
        :class="['tab-item']"
        :title="$t('H1208')"
        @toggle="changeCollapseStatus('indicators')"
      >
        <Indicators></Indicators>
      </CollapseItem>
      <CollapseItem
        v-if="hasZoneData"
        :active="collapseStatus.intervalData"
        :class="['tab-item']"
        :title="$t('H8001')"
        @toggle="changeCollapseStatus('intervalData')"
      >
        <IntervalDataCard></IntervalDataCard>
      </CollapseItem>

      <template v-if="commentPermission">
        <!--          评论-->
        <CollapseItem
          :active="collapseStatus.comment"
          :class="['tab-item']"
          @toggle="changeCollapseStatus('comment')"
        >
          <template #collapse-header>
            <div class="flex comment-top-bar">
              <span>{{ $t('H1201') }}</span>
              <span
                v-if="commentList"
                class="comment-count"
                >{{
                  $t('SQ1315', {
                    OvO: commentList ? commentList.length : 0
                  })
                }}</span
              >
              <span
                v-else-if="newMessageCount"
                class="new-comment-count"
                >{{
                  $t('SQ1316', {
                    OvO: newMessageCount
                  })
                }}</span
              >
            </div>
          </template>
          <Comment></Comment>
        </CollapseItem>

        <!--          训练感受-->
        <CollapseItem
          :active="collapseStatus.trainingFeeling"
          :title="$t('R9023')"
          :class="['tab-item']"
          @toggle="changeCollapseStatus('trainingFeeling')"
        >
          <Feeling></Feeling>
        </CollapseItem>

        <!--          训练笔记-->
        <CollapseItem
          :active="collapseStatus.sportNote"
          :title="$t('TD1060')"
          :class="['tab-item']"
          @toggle="changeCollapseStatus('sportNote')"
        >
          <Note></Note>
        </CollapseItem>
      </template>
    </div>
  </aside>
</template>

<script setup>
import { computed, reactive } from 'vue';

import { activityDetailStore } from '@client/store/activityDetailStore';
import TestPace from './TestPace/TestPace.vue';
import Muscle from './muscle/index.vue';
import SportMap from './sport-map/index.vue';
import Note from './Note.vue';
import Comment from './Comment.vue';
import Feeling from './feel/Feeling.vue';
import Indicators from './indicators/Indicators.vue';
import PostureTest from './PostureTest/PostureTest.vue';
import IntervalDataCard from './interval-data-card/interval-data-card.vue';
import CollapseItem from './CollapseItem.vue';
import Definition from '@client/config/definition';
import { useRoute } from 'vue-router';
import { useZoneData } from '../hooks/useZoneData';

const route = useRoute();
const { hasZoneData } = useZoneData();
const activityDetailStoreRef = activityDetailStore();
const { dataLoaded } = activityDetailStoreRef;
const collapseStatus = reactive({
  testPace: false,
  indicators: false,
  intervalData: false,
  comment: false,
  trainingFeeling: false,
  sportNote: false,
  postureTest: false
});
function changeCollapseStatus(type) {
  const newStatus = !collapseStatus[type];

  const keys = Object.keys(collapseStatus);
  if (keys.length === 0) {
    return;
  }
  if (!keys.includes(type)) {
    type = keys[0];
  }
  if (newStatus) {
    keys.forEach((key) => {
      collapseStatus[key] = key === type;
    });
  } else {
    collapseStatus[type] = newStatus;
  }
}
function setDefaultTab() {
  if (route.query?.collapse) {
    collapseStatus[route.query.collapse] = true;
  } else {
    if (isTestPace.value) {
      collapseStatus.testPace = true;
    } else if (hasPostureTest.value) {
      collapseStatus.postureTest = true;
    } else {
      collapseStatus.indicators = true;
    }
  }
}

// 是否为体测数据

const isTestPace = computed(() => activityDetailStoreRef.isTestPace);
// // 是否有跑姿测试结果
const hasPostureTest = computed(() => activityDetailStoreRef.hasPostureTest);

const commentList = computed(() => activityDetailStoreRef.commentList);
const newMessageCount = computed(() => activityDetailStoreRef.newMessageCount);
const commentPermission = computed(() => activityDetailStoreRef.commentPermission);
const sportType = computed(() => activityDetailStoreRef.sportType);
// // 是否显示肌肉图卡片
const showMuscleCard = computed(() => {
  const sportName = Definition.getSportNameByType(sportType.value);
  return ['Strength'].includes(sportName);
});
// // 是否显示地图卡片
const hasMapCard = computed(() => activityDetailStoreRef.hasMapCard);
const mapCardVisible = computed(() => activityDetailStoreRef.mapCardVisible);
const activityDetail = activityDetailStoreRef.activityDetail;
if (dataLoaded) {
  setDefaultTab();
}
</script>

<style lang="scss" scoped>
@import '@client/styles/_mixins.scss';

.sidebar {
  background: #181e30;
  transition: width 0.1s linear;
}

.tab-item {
  flex-grow: 0;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;

  &.active {
    flex-grow: 1;
    flex-shrink: 1;
    overflow: auto;
  }
}

.sport-map {
  height: 248px;
}

.comment-top-bar {
  justify-content: space-between;

  .comment-count {
    font-size: 14px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.6);
  }

  .new-comment-count {
    font-size: 14px;
    font-weight: 400;
    color: #00b3ff;
  }
}
</style>
